/*
 * Validates a Gift Card Number.
 */
const { some, startsWith } = require('lodash');

module.exports = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link(scope, element, attrs, $ctrl) {
            const giftCardNumberValidation = JSON.parse(attrs.wowGiftCardNumberValidation);
            const allowedBins = giftCardNumberValidation.allowedBins;
            const cardDigitLength = giftCardNumberValidation.cardDigitLength;

            function isValidPartialPin(partialPin, binToTest) {
                const length = Math.min(partialPin.length, binToTest.length);
                for (let i = 0; i < length; i++) {
                    if (partialPin[i] !== binToTest[i]) {
                        return false;
                    }
                }
                return true;
            }

            $ctrl.$validators.giftCardNumberPartial = (modelValue, viewValue) => {
                if ($ctrl.$isEmpty(modelValue) || !allowedBins || !allowedBins.length) {
                    return true;
                }

                // For a gift card number to be valid it must start with a certain prefix
                // Validate only until the latest number entered
                return some(allowedBins, bin => isValidPartialPin(viewValue, bin));
            };

            $ctrl.$validators.giftCardNumber = (modelValue, viewValue) => {
                if ($ctrl.$isEmpty(modelValue) || !allowedBins || !allowedBins.length) {
                    return true;
                }

                // For a gift card number to be valid it must start with a certain prefix and also 19 digits long
                return some(allowedBins, bin => startsWith(viewValue, bin) && viewValue.length === cardDigitLength);
            };
        },
    };
};



// WEBPACK FOOTER //
// ./src/wallet/giftcard/gift-card-number-validation.directive.js